import { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import MainCard from './MainCard';
import { Grid, Typography } from '@ts/storybook';
import _ from 'lodash';
import { IDataChart } from '@ts/ui-models';
import { ApexOptions } from 'apexcharts';
import { useTheme } from '@mui/material/styles';

// Chart options
const barChartOptions: ApexOptions = {
  chart: {
    height: 470,
    type: 'bar',
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: '70%',
      barHeight: '70%',
    },
  },
  colors: ['#00E396'],
  dataLabels: {
    enabled: false,
  },
  legend: {
    show: true,
    showForSingleSeries: true,
    customLegendItems: [],
    markers: {
      fillColors: ['#00E396', '#775DD0', '#FF0000', '#FF0000'],
    },
  },
};

const mockQuantityData = (): IDataChart => {
  return {
    xaxis: {
      categories: ['CP-Parking G', 'CP-Parking P1', 'CP-Check in 2', 'Lobby-EU', 'Lobby-USA', 'Gates 1-30', 'Gates 31-50'],
    },
    series: [8, 30, 25, 6, 20, 20, 20],
    labels: ['Actual', 'Expected', 'Max', 'Min'],
    options: {
      goals: {
        Max: [10, 32, 25, 6, 20, 22, 45],
        Expected: [9, 30, 23, 6, 10, 20, 43],
        Min: [6, 28, 25, 6, 3, 18, 40],
      },
    },
  };
};

const mockQuantityData1 = (): IDataChart => {
  return {
    xaxis: {
      categories: ['Week 1', 'Week 2', 'Week 3', 'Week 4', 'Week 5', 'Week 6', 'Week 7', 'Week 8'],
    },
    series: [300, 432, 423, 653, 800, 800, 900, 500],
    labels: ['Actual', 'Expected'],
    options: {
      goals: {
        Expected: [300, 400, 250, 400, 420, 650, 880, 790],
      },
    },
  };
};

const ColumnsWithMarkersChart = props => {
  const theme = useTheme();
  const mockData = props.type === 1 ? mockQuantityData() : mockQuantityData1();
  const [options, setOptions] = useState<ApexOptions>(barChartOptions);
  const [series, setSeries] = useState<any>(null);

  //#region Functions
  const generateDataChart = () => {
    const generateSeries = () => {
      return mockData.xaxis?.categories?.map((category, index) => {
        const goals = mockData.labels
          ?.filter(label => label !== 'Actual')
          .map(label => {
            return {
              name: label,
              value: mockData.options.goals[label][index],
              strokeHeight: label === 'Expected' ? 5 : 2,
              strokeColor: label === 'Expected' ? '#5d87d0' : '#FF0000',
              strokeDashArray: label === 'Expected' ? 0 : 2,
            };
          });

        return {
          x: category,
          y: mockData.series[index],
          goals: goals,
        };
      });
    };

    return [{ name: 'Actual', data: generateSeries() }];
  };

  const generateColor = () =>
    function ({ value, dataPointIndex }) {
      const maxGoal = mockData.options.goals['Max'][dataPointIndex];
      const minGoal = mockData.options.goals['Min'][dataPointIndex];
      const expGoal = mockData.options.goals['Expected'][dataPointIndex];

      if (value < minGoal) {
        return theme.palette.error.main;
      } else if (value > maxGoal) {
        return theme.palette.error.main;
      } else if (value === expGoal) {
        return theme.palette.success.main;
      } else {
        return theme.palette.warning.main;
      }
    };
  const fillOptionsChart = (prevState: any) => {
    return {
      ...prevState,
      legend: {
        ...prevState.legend,
        customLegendItems: mockData.labels,
      },
      ...(props.type === 1 && { colors: [generateColor()] }),
      xaxis: {
        categories: ['CP-Parking G', 'CP-Parking P1', 'CP-Check in 2', 'Lobby-EU', 'Lobby-USA', 'Gates 1-30', 'Gates 31-50'],
      },
      //categories: mockData?.xaxis?.categories,
    };
  };
  //#endregion

  useEffect(() => {
    setOptions(prevState => fillOptionsChart(prevState));
    setSeries(generateDataChart());
  }, []);

  if (!series) return;

  return (
    <MainCard contentSX={{ p: 2.25 }}>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid mb={1.5}>{props.title && <Typography variant="h5" fontWeight="500" color="primary" text={props.title} />}</Grid>
      </Grid>

      <div style={{ overflow: 'auto', position: 'relative' }}>
        <div style={{ minWidth: '100%', minHeight: '502px' }}>
          {/* @ts-ignore */}
          <ReactApexChart
            options={options}
            series={series}
            type={barChartOptions.chart?.type}
            height={barChartOptions.chart?.height}
          />
        </div>
      </div>
    </MainCard>
  );
};

export default ColumnsWithMarkersChart;
